import { Divider, Stack } from '@mui/material';
import { FirstSegment } from './FirstSegment';
import { SecondSegment } from './SecondSegment';
import { ActionButtons } from './ActionButtons';

interface ISearchForm {
  closeAdvancedSearch: () => void;
}

export const SearchForm = ({ closeAdvancedSearch }: ISearchForm) => {
  return (
    <Stack gap={'32px'}>
      <FirstSegment />
      <Divider
        aria-hidden={'true'}
        sx={{
          borderColor: 'primary.shade_200',
        }}
      />
      <Stack gap={'48px'}>
        <SecondSegment />
        <ActionButtons closeAdvancedSearch={closeAdvancedSearch} />
      </Stack>
    </Stack>
  );
};
